module.exports = __webpack_public_path__ + "static/media/doc_browser_light.65badeaf.svg";